// extracted by mini-css-extract-plugin
export default {"price":"C7-z","onSale":"D7-z","msrpLabelPrice":"E7-z","msrpLabel":"F7-z","originalPrice":"G7-z","percentOff":"H7-z"};